import { PermissionsConstants, Selector } from 'src/common/types';
import DataStore, { Query, QueryResult } from 'src/core/stores/data-store';
import FormStore from 'src/core/stores/form-store';
import { CommandResult } from 'src/core/stores/types';

export interface PermissionRoleItem {
  roleId: string;
  name: string;
}

export interface PermissionSummary {
  id: string;
  name: string;
  description: string;
  selector: Selector;
}

export interface PermissionItem {
  id: string;
  name: string;
  description: string;
  selector: Selector;
  roles: PermissionRoleItem[];
}

export interface CreatePermissionItem {
  name: string;
  description: string;
  selector: Selector;
}

export interface UpdatePermissionItem {
  name: string;
  description: string;
  selector: Selector;
}

export class PermissionSummaryStore extends DataStore<PermissionSummary> {
  constructor(baseUrl: string) {
    super(`${baseUrl}/identity/api/permissions`, []);
  }

  public async loadPermissions(query: Partial<Query>) {
    return (
      (await this.handleCallAsync(async () => {
        var response = await this.httpService.get<QueryResult<PermissionSummary>>(`${this.baseUrl}?${DataStore.buildUrl(query as Query)}`);
        this._state.set((s) => {
          s.items = response.data.items || [];
          s.count = response.data.count || 0;
          return s;
        });
        return response.data.items;
      })) ?? []
    );
  }
}

const hiddenPermissions = [PermissionsConstants.UseStructMaster];

export const permissionIsHidden = (permission: PermissionsConstants) => {
  return hiddenPermissions.includes(permission);
};

export class PermissionItemStore extends FormStore<PermissionItem, CreatePermissionItem> {
  constructor(baseUrl: string) {
    super(`${baseUrl}/identity/api/permissions`);
  }

  groupRolesBasePath = 'roles';

  public async addPermissionRoles(id: string, roleIds: string[]) {
    return await this.handleCallAsync(async () => {
      var result = await this.httpService.post<{ roles: string[] }, CommandResult<{ roles: string[] }>>(
        `${this.baseUrl}/${encodeURIComponent(id)}/${this.groupRolesBasePath}`,
        { roles: roleIds }
      );
      return result.data;
    });
  }

  public async deletePermissionRoles(id: string, roleIds: string[]) {
    return await this.handleCallAsync(async () => {
      var result = await this.httpService.delete<{ roles: string[] }, CommandResult<{ roles: string[] }>>(
        `${this.baseUrl}/${encodeURIComponent(id)}/${this.groupRolesBasePath}`,
        { roles: roleIds }
      );
      return result.data;
    });
  }
}
